import { MaterialIcon } from '@makyoapp/makyo-tw-ui'

export const PLUGIN_ACTIONS = {
  GMAIL: {
    type: 'PLUGIN_GMAIL',
    label: 'Gmail',
    icon: <MaterialIcon icon='mail' size={16} className='text-gray-500 dark:text-slate-400' />,
  },
}

export type PluginAction = typeof PLUGIN_ACTIONS
